module.exports.DEFAULT_ERROR_MESSAGE = 'Errors occured, please try again later';

module.exports.SYSTEM_ERROR_MESSAGE = 'System error occured, please try again later';

module.exports.NO_ACCESS_ERROR_MESSAGE = 'User has no access to this function';

module.exports.DO_NOT_HAVE_RIGHTS_MESSAGE = "You don't have rights to access";

module.exports.API_ID_ERROR = 'Get App ID first!';

module.exports.MEETING_ERROR = 'Not a valid meeting';

module.exports.APPJSON = 'application/json';

module.exports.QUERY_DATE_FORMAT = 'YYYY-MM-DD';

module.exports.QUERY_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]';

module.exports.ORGANIZATION_NOT_FOUND = 'Organization not found';

module.exports.GOOGLE_API_KEY = 'AIzaSyBAg_STV5NwQfuUGdqakx1_Zbv5UGTn3lc';

module.exports.TOKEN_NOT_FOUND_ERROR = 'Token is not provided';

module.exports.USER_NOT_FOUND_ERROR_MESSAGE = 'User not found';

module.exports.ORGANIZATION_TAGS = {
    HDI: 'hdi',
    FREEMIUM: 'freemium',
    DAMAGE_NOTICE: 'damage-notice',
};
